import { EntityDataTypes, knownCentralEntityTypes, knownEntityTypes } from 'src/interfaces/modular/entityInfoTypes';
class EntityEntryPointHelper {
    createdInstancesMap = {};
    getInstance(name, id) {
        id = String(id);
        if (!this.createdInstancesMap[name])
            this.createdInstancesMap[name] = {};
        if (!this.createdInstancesMap[name][id])
            this.createdInstancesMap[name][id] = this.createInstance(name, id);
        return this.createdInstancesMap[name][id];
    }
    createInstance(name, id) {
        return {
            type: EntityDataTypes.Instance,
            name,
            id
        };
    }
    user(id) {
        return this.getInstance(knownEntityTypes.User, id);
    }
    userGroup(id) {
        return this.getInstance(knownEntityTypes.UserGroup, id);
    }
    company(id) {
        return this.getInstance(knownCentralEntityTypes.Company, id);
    }
}
export const getEntity = new EntityEntryPointHelper();
